import apiSaga from 'legacy/src/shared/util/apiSagaGenerator';
import { takeLatest, all } from 'redux-saga/effects';
import { fetchAssignments } from './actions';

/**
 * Fetch assignments saga.
 * Create a new api saga for fetching assignments.
 *
 * @param {Object} options.payload Data object.
 * @yield {apiSaga}                Api Response.
 */
function* fetchAssignmentsSaga({ payload }) {
  yield apiSaga(fetchAssignments, {
    url: `assessments/api/assignments/`,
    data: payload.params,
    silent: payload.silent,
  });
}

/**
 * apstudent Saga
 *
 * yield {Saga} All sagas that belong to apstudent.
 */
export default function* apstudentSaga() {
  yield all([takeLatest(fetchAssignments.TRIGGER, fetchAssignmentsSaga)]);
}
